import { useEffect } from 'react';
import { useAuthStore } from '@/store/useAuthStore';
import { authService } from '@/services/authService';

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const { setFirebaseUser, setUserProfile, setLoading } = useAuthStore();

  useEffect(() => {
    setLoading(true);
    
    const unsubscribe = authService.onAuthStateChanged(async (user) => {
      if (user) {
        setFirebaseUser(user);
        
        try {
          // First try to get profile from Firestore (for display name, etc.)
          const firestoreProfile = await authService.getUserProfile(user.uid);
          
          // Then sync with backend to get usage stats and ensure user exists there
          const backendProfile = await authService.syncCurrentUserWithBackend();
          
          // Merge profiles, preferring backend data for usage stats
          const mergedProfile = {
            ...firestoreProfile,
            ...backendProfile,
            uid: user.uid,
            email: user.email || firestoreProfile?.email || backendProfile?.email || '',
            displayName: firestoreProfile?.displayName || backendProfile?.displayName || user.displayName || '',
          };
          
          setUserProfile(mergedProfile);
        } catch (error) {
          console.error('Error syncing user profile:', error);
          // Fall back to basic profile from Firebase user
          setUserProfile({
            uid: user.uid,
            email: user.email || '',
            displayName: user.displayName || '',
            plan: 'free',
          });
        }
      } else {
        setFirebaseUser(null);
        setUserProfile(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [setFirebaseUser, setUserProfile, setLoading]);

  return <>{children}</>;
};

